<p>If you leave this page, unsaved changes will be lost. What do you want to do?</p>
<div class="actions">
  <button class="nav-action-btn" [disabled]="disabled" (click)="undo()">Undo changes</button>
  <button class="nav-action-btn good" [disabled]="disabled" (click)="save()">Save changes</button>
</div>
